module.exports = __webpack_public_path__ + "logo-white-email-4348c3bd06f4efdac2a65a378cc1c18a.png";